import { render, staticRenderFns } from "./SalesHistory.vue?vue&type=template&id=5c1d8bdb&scoped=true&"
import script from "./SalesHistory.vue?vue&type=script&lang=js&"
export * from "./SalesHistory.vue?vue&type=script&lang=js&"
import style0 from "./SalesHistory.vue?vue&type=style&index=0&id=5c1d8bdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d8bdb",
  null
  
)

export default component.exports